
import { UPDATE_CONFIGURATION } from './actions';

export const updateConfiguration = (payload: any) => ({
  type: UPDATE_CONFIGURATION,
  payload
})

